'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationHistory', ['$scope', 'Permissions', '$q', '$rootScope', '$sce', '$stateParams', 'ComplaintActivityTracking', 'Format', function ($scope, Permissions, $q, $rootScope, $sce, $stateParams, ComplaintActivityTracking, Format) {
        $scope.resetInvestigation();
        $scope.vm = {
            search: '',
            user: null,
            date: null
        };

        $scope.clear = function () {
            $scope.vm.search = '';
            $scope.vm.user = null;
            $scope.vm.date = null;
        }

        $scope.userOptions = [
            { id: null, name: 'All Users' },
            { id: $rootScope.userAccount.id, name: 'My Activity' }
        ];

        $scope.dateOptions = [
            { id: 0, name: 'Today' },
            { id: 1, name: 'Yesterday' },
            { id: 7, name: 'Last 7 Days' },
            { id: 30, name: 'Last 30 Days' },
            { id: 90, name: 'Last 90 Days' }
        ]
        
        $scope.$watch('investigationLoading', function () {
            if (!$scope.investigationLoading) {
                var a = Permissions.view('internal.licensing.investigation.documents');
                var b = Permissions.view('internal.licensing.investigation.notes');
                var c = Permissions.view('internal.licensing.investigation.correspondences');
                var d = Permissions.view('internal.licensing.investigation.activitytracking');
                //Separate api call to get activity tracking history (to not bog down the main complaint call and to put it in core)
                var e = ComplaintActivityTracking.getActivityTrackingHistoryByComplaintID($stateParams.id);

                $q.all([a, b, c, d, e]).then(function (results) {
                    var documentPermission = results[0];
                    var notePermission = results[1];
                    var correspondencePermission = results[2];
                    var activityTrackingPermission = results[3];
                    var complaintActivityTrackingHistory = results[4];

                    var activities = [];
                    $scope.investigation.complaint_status_history.forEach(function (sh) {
                        var activity = {};
                        activity.details = sh.complaint_status_name;
                        activity.category = 'Status';
                        activity.state = 'internal.licensing.investigation.details';
                        activity.parameters = {};
                        activity.createdon = sh.createdon;
                        activity.createdby = sh.createdby;
                        activity.entered_by = sh.entered_by;
                        activity.all = null;
                        activities.push(activity);
                    })

                    if (documentPermission) {
                        $scope.investigation.documents.forEach(function (d) {
                            var activity = {};
                            activity.details = d.name;
                            activity.category = 'Document';
                            activity.state = 'internal.licensing.investigation.document';
                            activity.parameters = { investigationDocumentID: d.id };
                            activity.createdon = d.createdon;
                            activity.createdby = d.createdby;
                            activity.entered_by = d.entered_by;
                            activity.all = null;
                            activities.push(activity);
                        })
                    }

                    if (notePermission) {
                        $scope.investigation.notes.forEach(function (n) {
                            var activity = {};
                            activity.details = $sce.trustAsHtml(n.note_display);
                            activity.category = 'Note';
                            activity.state = 'internal.licensing.investigation.note';
                            activity.parameters = { investigationNoteID: n.id };
                            activity.createdon = n.createdon;
                            activity.createdby = n.createdby;
                            activity.entered_by = n.entered_by;
                            activity.all = null;
                            activities.push(activity);
                        })
                    }

                    if (correspondencePermission) {
                        $scope.investigation.correspondences.forEach(function (c) {
                            var activity = {};
                            activity.details = c.subject;
                            activity.category = 'Correspondence';
                            activity.state = 'internal.licensing.investigation.correspondence';
                            activity.parameters = { investigationCorrespondenceID: c.id };
                            activity.createdon = c.createdon.revertTimeZone();
                            activity.createdby = c.createdby;
                            activity.entered_by = c.entered_by;
                            activity.all = null;
                            activities.push(activity);
                        })
                    }

                    if (activityTrackingPermission && complaintActivityTrackingHistory) {
                        complaintActivityTrackingHistory.forEach(function (history) {
                            var activity = {};
                            if (!history.activityTrackingActive) {
                                activity.details = "Activity Tracking Deleted"
                            }
                            else {
                                activity.details = "Type: " + history.activityTypeName + "<br>";
                                if (history.startDate) {
                                    activity.details += "Start Date: " + new Date(history.startDate).toLocaleString([], Format.nativeJSDateFormat('MM/DD/YYYY hh:mm')) + "<br>";
                                }
                                if (history.endDate) {
                                    activity.details += "End Date: " + new Date(history.endDate).toLocaleString([], Format.nativeJSDateFormat('MM/DD/YYYY hh:mm')) + "<br>";
                                }
                                if (history.note) {
                                    activity.details += "Note: " + history.note;
                                }
                            }
                            activity.category = 'Activity Tracking';
                            activity.state = 'internal.licensing.investigation.activitytrackinghistory';
                            activity.parameters = { investigationActivityTrackingID: history.complaintActivityTrackingId, investigationActivityTrackingHistoryID: history.id  };
                            activity.createdon = new Date(history.createdOnUtc);
                            activity.createdby = history.createdByFullName;
                            activity.entered_by = history.createdBy;
                            activity.all = null;
                            activities.push(activity);
                        })
                    }

                    $scope.investigation.history = [];
                    var date = null;
                    activities.sort(sortObjectArray('-createdon')).forEach(function (activity) {
                        if (date == null) {
                            date = {};
                            date.activities = [];
                            date.day = activity.createdon;
                            date.activities.push(activity);
                        }
                        else {
                            if (activity.createdon.toDateString() == date.day.toDateString()) {
                                date.activities.push(activity);
                            }
                            else {
                                $scope.investigation.history.push(date);
                                date = {};
                                date.activities = [];
                                date.day = activity.createdon;                    
                                date.activities.push(activity);
                            }
                        }
                    })
                    if (date != null) {
                        $scope.investigation.history.push(date);
                    }
                }).catch(function (response) {
                    // handle error
                });
            }
        })
    }])
;